export enum CourseType {
  main = 'main',
  soup = 'soup',
  dessert = 'dessert',
  beverage = 'beverage',
  pastry = 'pastry',
}

export enum Daypart {
  lunch = 'lunch',
  dinner = 'dinner',
  breakfast = 'breakfast',
  afternoon = 'afternoon',
}

export enum DietaryRestriction {
  vegan = 'vegan',
  vegetarian = 'vegetarian',
  pescatarian = 'pescatarian',
  gluten_free = 'gluten_free',
  lactose_free = 'lactose_free',
  dairy_free = 'dairy_free',
  nut_free = 'nut_free',
  halal = 'halal',
  kosher = 'kosher',
  no_beef = 'no_beef',
  no_pork = 'no_pork',
  jain = 'jain',
  low_sodium = 'low_sodium',
  keto = 'keto',
  diabetic_friendly = 'diabetic_friendly',
}

export enum DishType {
  main = 'main',
  soup = 'soup',
  dessert = 'dessert',
}

export enum IssueStatus {
  WIP = 'WIP',
  Pending = 'Pending',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
}

export enum LineStatus {
  selected = 'selected',
  skipped = 'skipped',
}

export enum MealTime {
  lunch = 'lunch',
  dinner = 'dinner',
}

export enum MenuStatus {
  draft = 'draft',
  published = 'published',
}

export enum SlotDecision {
  no_meal = 'no_meal',
  meal = 'meal',
  pending = 'pending',
}

export enum UserRole {
  admin = 'admin',
  kitchen = 'kitchen',
  employee = 'employee',
}

export enum UserStatus {
  pending = 'pending',
  active = 'active',
  rejected = 'rejected',
  disabled = 'disabled',
}
